<template>
    <div class="about-us-container">
      <!-- 英雄部分 -->
      <section class="hero-section">
        <img src="/images/团队封面.png" alt="" style="width: 100%;height: 400px;">
      </section>
  
      <!-- 公司故事部分 -->
      <section class="story-section">
        <div class="section-container">
          <div class="story-content">
            <div class="story-text">
              <h2>我们的故事</h2>
              <p>
                我们是由软件工程专业学生组成的学科团队，专注用技术创新活化传统文化。本次《晋韵寻踪》项目开发了融合三维建模与AR交互的山西文化遗产数字平台，通过实现古建构件识别及动态展示交互，助力于山西文化传播，希望能作为AI、IT技术带动山西旅游发展和文化传播的模板              </p>
              <p>
                我们相信创新、质量和客户至上。我们做出的每一个决定都受到这些核心价值观的指导，
                确保我们在所做的一切中提供卓越的价值。
              </p>
            </div>
            <div class="story-image">
              <img src="/images/关于我们海报.png" alt="公司办公室">
            </div>
          </div>
        </div>
      </section>
  
      <!-- 团队部分 -->
      <section class="team-section">
        <div class="section-container">
          <h2>认识我们的团队</h2>
          <div class="team-grid">
            <!-- 团队成员 1 -->
            <div class="team-member">
              <div class="member-image">
                <img src="/images/人物头像代替.png" alt="团队成员">
              </div>
              <h3>情忆楠楠而眠</h3>
              <p class="member-title">技术主要负责人</p>
              <p class="member-bio">
                熟练使用各种开发及ai相关技术，善于开发及算法设计
              </p>
            </div>
            
            <!-- 团队成员 2 -->
            <div class="team-member">
              <div class="member-image">
                <img src="/images/人物头像代替.png" alt="团队成员">
              </div>
              <h3>Z_J_X</h3>
              <p class="member-title">开发辅助及团队沟通</p>
              <p class="member-bio">
                负责辅助代码开发以及相关的团队成员之间的沟通
              </p>
            </div>
            
            <!-- 团队成员 3 -->
            <div class="team-member">
              <div class="member-image">
                <img src="/images/女性人物头像.png" alt="团队成员">
              </div>
              <h3>jiongjiong</h3>
              <p class="member-title">美感设计及数据处理负责人</p>
              <p class="member-bio">
                WJH在为团队提供并设计整体美观及细节美观处理的同时负责帮助处理数据
              </p>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 价值观部分 -->
      <section class="values-section">
        <div class="section-container">
          <h2>我们的价值观</h2>
          <div class="values-grid">
            <!-- 价值观 1 -->
            <div class="value-card">
              <div class="value-icon">★</div>
              <h3>创新</h3>
              <p>
                我们不断突破界限，探索新想法，以创造更好的解决方案。
              </p>
            </div>
            
            <!-- 价值观 2 -->
            <div class="value-card">
              <div class="value-icon">❤</div>
              <h3>激情</h3>
              <p>
                我们热爱我们所做的，并将热情投入到我们承担的每一个项目中。
              </p>
            </div>
            
            <!-- 价值观 3 -->
            <div class="value-card">
              <div class="value-icon">🤝</div> <!-- 修改为更合适的图标 -->
              <h3>合作</h3>
              <p>
                我们相信，当我们与客户和彼此携手合作时，伟大的事情会发生。
              </p>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 联系部分 -->
      <section class="contact-section">
        <div class="section-container">
          <h2>联系我们</h2>
          <p>有疑问或想了解更多关于我们公司的信息？我们很高兴听到您的声音！</p>
          <button class="contact-button" @click="handleContactClick">联系我们</button>
        </div>
      </section>
    </div>
  </template>
  
  <script setup>
  
  // 简单的函数来处理联系按钮点击
  const handleContactClick = () => {
    alert('联系表单将会在此处打开');
  };
  </script>
  
  <style scoped>
  /* 基本重置 */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  /* 变量 */
  :root {
    --primary-color: #4a6fa5;
    --secondary-color: #f8f9fa;
    --text-color: #333;
    --light-text: #666;
    --spacing-unit: 1rem;
  }
  
  /* 容器 */
  .about-us-container {
    font-family: Arial, sans-serif;
    color: var(--text-color);
    line-height: 1.6;
  }
  
  /* 部分样式 */
  .section-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 var(--spacing-unit);
  }
  
  section {
    padding: 4rem 0;
  }
  
  section h2 {
    font-size: 2rem;
    margin-bottom: 2rem;
    text-align: center;
  }
  
  /* 英雄部分 */
  .hero-section {
    background-color: var(#f9f5f0);
    color: white;
    text-align: center;
    padding: 5rem 1rem;
  }
  
  .hero-content {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .hero-section h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }
  
  .hero-section p {
    font-size: 1.2rem;
  }
  
  /* 故事部分 */
  .story-section {
    background-color: var(#f9f5f0);
  }
  
  .story-content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  
  @media (min-width: 768px) {
    .story-content {
      flex-direction: row;
    }
    
    .story-text, .story-image {
      flex: 1;
    }
  }
  
  .story-text h2 {
    text-align: left;
    margin-bottom: 1rem;
  }
  
  .story-text p {
    margin-bottom: 1rem;
  }
  
  .story-image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  /* 团队部分 */
  .team-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  @media (min-width: 768px) {
    .team-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  .team-member {
    text-align: center;
  }
  
  .member-image {
    width: 150px;
    height: 150px;
    margin: 0 auto 1rem;
    overflow: hidden;
    border-radius: 50%;
  }
  
  .member-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .team-member h3 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
  }
  
  .member-title {
    color: var(--light-text);
    margin-bottom: 0.5rem;
  }
  
  /* 价值观部分 */
  .values-section {
    background-color: var(#f9f5f0);
  }
  
  .values-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  @media (min-width: 768px) {
    .values-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  .value-card {
    background-color: white;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .value-icon {
    font-size: 2rem;
    margin-bottom: 1rem;
    color: var(--primary-color);
  }
  
  /* 修改了图标以更好地表示“合作” */
  .value-card h3 {
    margin-bottom: 1rem;
  }
  
  /* 联系部分 */
  .contact-section {
    text-align: center;
  }
  
  .contact-section p {
    max-width: 600px;
    margin: 0 auto 2rem;
    font-size: 1.1rem;
  }
  
  .contact-button {
    background-color: var(--primary-color);
    color: white;
    border: none;
    padding: 0.75rem 2rem;
    font-size: 1rem;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .contact-button:hover {
    background-color: #3a5a8c;
  }
  </style>